module finadai.app.negotiations.detail {
    export var NAME = 'finadai.app.negotiations.detail';
    import Records = models.http.responses.Records;
    import Record = models.http.responses.Record;
    import PaymentType = models.PaymentType;
    interface FormDataNegotiation {
        payment_amount: number;
        down_payment: number;
        payment_type_id: number;
        customer_id: number;
        credits: any;
        activity_id: number;
    }
    class NegotiationDetailController {
        formData: FormDataNegotiation;
        paymentTypes: models.PaymentType[] = [];
        processingRequest: boolean = false;
        sendText: string = 'Validar negociación';
        customer: models.Customer;
        credits: models.Credit[];
        negotiation: models.Negotiation = null;
        statusPayment = {
            paid: {
                label: 'Pagado',
                class: 'success'
            },
            pending_payment: {
                label: 'Pendiente',
                class: 'warning'
            },
            expired: {
                label: 'Expirado',
                class: 'danger'
            }
        }

        constructor(private $state: ng.ui.IStateService,
                    private negotiationsService: services.NegotiationsService,
                    private $mdDialog: ng.material.IDialogService,
                    private $rootScope,
                    private notify,
                    private $stateParams,
                    credits: ng.IHttpPromiseCallbackArg<Records<models.Credit>>,
                    negotiation: ng.IHttpPromiseCallbackArg<Record<models.Negotiation>>) {
            if ($state.is('app.negotiations.create')) {
                this.credits = credits.data.data;
                this.customer = this.credits[0].customer;
                this.formData = {
                    activity_id: $stateParams.activityId,
                    credits: this.credits.map(x => {
                        return {id: x.id}
                    }),
                    customer_id: this.customer.id,
                    payment_amount: null,
                    payment_type_id: null,
                    down_payment: null
                }
            }
            else {
                this.negotiation = negotiation.data.data;
                this.credits = this.negotiation.credits;
                this.customer = this.negotiation.customer;
                this.generatePayments();
            }
            angular.forEach(this.credits, (credit: models.Credit) => {
                if (credit.loan_type_id == 2) {
                    this.negotiationsService.getCoAcredits(credit.loan_id, this.customer.id).then(response => {
                        credit.co_accredit_data = response.data.data;
                    });
                }
            })
        }

        loadPaymentTypes() {
            var pending_amount = this.credits.reduce((acum, item) => acum + item.pending_amount, 0);
            var proposal_amount = this.formData.payment_amount-this.formData.down_payment;

            this.negotiationsService.getAvailablePaymentTypes({
                pending_amount: pending_amount,
                proposal_amount: proposal_amount
            }).then((response: any) => {
                this.formData.payment_type_id = null;
                this.paymentTypes = response.data;
            });
        }

        cleanFields() {
            this.formData.down_payment = 0;
            this.loadPaymentTypes();
        }

        send(form, event) {
            if (form.$valid) {
                this.processingRequest = true;
                this.sendText = 'Enviando negociación...';

                this.negotiationsService.save(this.formData).then(response => {
                    this.$state.go('app.negotiations.detail', {negotiationId: response.data.id});
                    this.dialogProposal(event, 1);
                    this.$rootScope.$broadcast('updatePendingNegotiations');
                }).catch(responseError => {
                    this.sendText = 'Validar negociacion';
                    this.processingRequest = false;
                });
            }
        }

        generatePayments() {
            if (this.negotiation.state == 'under_review') return '';
            this.negotiationsService.generatePayments({negotiation_id: this.negotiation.id}).then((response: any) => {
                this.negotiation.state = response.data.state;
                if (response.data.payments) {
                    this.negotiation.payments = response.data.payments;
                }
            }).catch(rejection => {
                var output = '<span class="block mt10">Ocurrió un problema al generar el listado de pagos</span>';
                if (rejection.status == 412 || rejection.status == 422 || rejection.status == 400) {
                    var errorsMessage = angular.isDefined(rejection.data.message) ? rejection.data.message : "Error";
                    if (typeof rejection.data.errors !== "string") {
                        output += '<ol>';
                        for (var field in rejection.data.errors) {
                            for (var errorType in rejection.data.errors[field]) {
                                var errorString = angular.isDefined(rejection.data.errors[field][errorType]["error"]) ? rejection.data.errors[field][errorType]["error"] : rejection.data.errors[field][errorType];
                                output += '<li>' + errorString + '</li>';
                            }
                        }
                        output += '</ol>';
                    }
                    else {
                        output += '<ol><li>' + errorsMessage + '</li></ol>';
                    }
                    this.notify(output, 'danger');
                }
            });
        }

        dialogProposal(ev, option) {
            var text;
            switch (option) {
                case 1:
                    text = '<md-dialog aria-label="Términos y condiciones"><md-dialog-content class="md-dialog-content">' +
                        '<p class="text-center"><img src="/assets/images/logo.png" width="100" /></p>' +
                        '<h4 class="text-center">' +
                        '<md-icon class="material-icons mt20 fs100 green">check_circle</md-icon></h4>' +
                        '<h5 class="text-center">Negociación creada</h5>' +
                        '</md-dialog-content>' +
                        '<md-dialog-actions><md-button class="md-accent md-raised" ng-click="close()">Ok</md-button></md-dialog-actions>' +
                        '</md-dialog>';
                    break;
                case 2:
                    text = '<md-dialog aria-label="Términos y condiciones"><md-dialog-content class="md-dialog-content">' +
                        '<p class="text-center"><img src="/assets/images/logo.png" width="100" /></p>' +
                        '<h4 class="text-center">Lo sentimos<br />' +
                        '<md-icon class="material-icons mt20 fs100 red">block</md-icon></h4>' +
                        '<h5 class="text-center">Propuesta rechazada</h5>' +
                        '</md-dialog-content>' +
                        '<md-dialog-actions><md-button ng-click="close()">Ok</md-button></md-dialog-actions>' +
                        '</md-dialog>';
                    break;
            }
            this.$mdDialog.show({
                template: text,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                controller: ($scope: any, $mdDialog) => {
                    $scope.close = () => {
                        $mdDialog.hide();
                    }
                },
                fullscreen: false // Only for -xs, -sm breakpoints.
            });
        }

        sendNegotiation(ev) {
            this.$mdDialog.show({
                controller: SendNegotiationController,
                templateUrl: 'app/customers/detail/formEmail.tpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                locals: {
                    config: {
                        entity: {add: 'Enviar email', save: 'Enviar'},
                        data: {negotiation_id: this.negotiation.id}
                    }
                }
            }).then(response => {
                this.notify('Negociación enviada');
            });
        }

        authorize() {
            this.negotiationsService.authorize(this.negotiation.id).then(response => {
                this.notify('Negociación autorizada');
                this.negotiation.state = response.data.state;
                this.generatePayments();
            });
        }
    }

    function SendNegotiationController(config, $mdDialog, $scope, negotiationsService: services.NegotiationsService) {
        $scope.config = config;
        $scope.formData = config.data;
        $scope.cancel = () => {
            $mdDialog.cancel()
        };
        $scope.submit = (form) => {
            if (form.$valid) {
                negotiationsService.send($scope.formData).then(response => {
                    $mdDialog.hide(response);
                });
            }
        }
    }

    // la cantidad de pagos por el motno que quieren pagar debe ser >= el porcentaje minimo por el amount_payable
    export function run() {
        var detail = angular.module(NAME, []);
        detail.controller('NegotiationDetailController', NegotiationDetailController)
    }
}
finadai.app.negotiations.detail.run();